import { pumaAPI } from "../api"
import { CollectionResourceDTO } from "../models/resources"
import { ICollection, IConcept } from "../../components/resources"

export const getCollection = (id: number): Promise<ICollection> =>
    pumaAPI
        .getJSON(`lists/smartlist${id}`)
        .then((Collection: CollectionResourceDTO) => {
            const { WorkspaceId, WorkspaceName, Label } = Collection

            const newCollection: IConcept = {
                id,
                title: Label,
                doesExist: true,
                workspace: {
                    id: WorkspaceId ?? 0,
                    title: WorkspaceName,
                    doesExist: true,
                },
            }

            return newCollection
        })
